import { Variants } from '@amplitude/experiment-js-client';

export type Values<T> = T[keyof T];

export const AmplitudeFlagKeys = {
  dontServeCustomers: 'online-booking-unavailable',
  allowForOldOnlinebooking: 'allow-for-old-online-booking',
  obArrivalStepImprovements: 'ob-arrival-step-improvements',
  obHideStepper: 'ob-hide-stepper',
  dynamicDurationInOlb: 'dynamic-duration-in-olb-and-ae',
} as const;

export type AmplitudeFlagType = Values<typeof AmplitudeFlagKeys>;

export const TruthyValuesForFlagKeys = {
  [AmplitudeFlagKeys.dontServeCustomers]: 'using-online-booking-unavailable',
  [AmplitudeFlagKeys.allowForOldOnlinebooking]: 'using-allow-for-old-online-booking',
  [AmplitudeFlagKeys.obArrivalStepImprovements]: 'using-ob-arrival-step-improvements',
  [AmplitudeFlagKeys.obHideStepper]: 'using-ob-hide-stepper',
  [AmplitudeFlagKeys.dynamicDurationInOlb]: 'using-dynamic-duration-in-olb-and-ae',
} as const satisfies Record<AmplitudeFlagType, string>;

export const DefaultFlagValues: Variants = {} as const;
